import { client } from "../client/client";

export const getLoanApplicationCounts = async () => {
  try {
    const response = await client.get(`/applications/status-counts`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanApplications = async (
  page,
  limit,
  from,
  to,
  search,
  status,
  loanOfficerId,
  productName,
  minBalance,
  maxBalance
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (from) params.append("from", from);
    if (to) params.append("to", to);
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (loanOfficerId) params.append("loanOfficerId", loanOfficerId);
    if (productName) params.append("productName", productName);
    if (minBalance) params.append("minBalance", minBalance);
    if (maxBalance) params.append("maxBalance", maxBalance);

    const response = await client.get(
      `/loan-applications?${params.toString()}`
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const createLoanApplication = async (
  customerId,
  loanOfficerId,
  productId,
  loanAmount,
  loanPeriod,
  purpose
) => {
  try {
    const response = await client.post(`/loan-application`, {
      customerId,
      loanOfficerId,
      productId,
      loanAmount,
      loanPeriod,
      source: "web",
      loanPurpose: purpose,
      application_stage: "init_application",
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getApplicationGuarantors = async (applicationId) => {
  try {
    const response = await client.get(`/guarantors/by-loan/${applicationId}`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const createApplicationGuarantors = async (
  loanApplication,
  guarantorName,
  guarantorPhone,
  guarantorEmail,
  residenceCounty,
  residenceSubCounty,
  residenceWard,
  residenceVillage,
  residenceLatitude,
  residenceLongitude,
  signatureUrl,
  guaranteeAmount,
  reason,
  guarantorPhoto,
  guarantorBusinessPhoto,
  residenceLocation
) => {
  try {
    const response = await client.post(`/guarantors`, {
      loanApplicationId: loanApplication,
      guarantorName,
      guarantorPhone,
      guarantorEmail,
      residenceCounty,
      residenceSubCounty,
      residenceWard,
      residenceVillage,
      residenceLatitude,
      residenceLongitude,
      signatureUrl,
      guaranteeAmount: Number(guaranteeAmount),
      reason,
      guarantorPhoto,
      guarantorBusinessPhoto,
      residenceLocation,
    });
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateApplicationGuarantor = async (
  id,
  guarantorName,
  guarantorPhone,
  guarantorEmail,
  residenceCounty,
  residenceSubCounty,
  residenceWard,
  residenceVillage,
  residenceLatitude,
  residenceLongitude,
  signatureUrl,
  guaranteeAmount,
  reason,
  guarantorPhoto,
  guarantorBusinessPhoto,
  residenceLocation
) => {
  try {
    let payload = {
      guarantorName,
      guarantorPhone,
      guarantorEmail,
      residenceCounty,
      residenceSubCounty,
      residenceWard,
      residenceVillage,
      residenceLatitude,
      residenceLongitude,
      signatureUrl,
      guaranteeAmount:
        guaranteeAmount !== undefined &&
        guaranteeAmount !== null &&
        guaranteeAmount !== ""
          ? Number(guaranteeAmount)
          : undefined,
      reason,
      guarantorPhoto,
      guarantorBusinessPhoto,
      residenceLocation,
    };

    // Remove null, undefined, and empty string values
    Object.keys(payload).forEach(
      (key) =>
        (payload[key] === null ||
          payload[key] === undefined ||
          payload[key] === "") &&
        delete payload[key]
    );

    const response = await client.patch(`/guarantors/${id}`, payload);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
export const updateApplicationGuarantorLocation = async (
  id,
  residenceLatitude,
  residenceLongitude,
  residenceLocation
) => {
  try {
    let payload = {
      residenceLatitude,
      residenceLongitude,
      residenceLocation,
    };
    Object.keys(payload).forEach(
      (key) =>
        (payload[key] === null ||
          payload[key] === undefined ||
          payload[key] === "") &&
        delete payload[key]
    );

    const response = await client.patch(`/guarantors/${id}`, payload);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteGuarantor = async (id) => {
  try {
    const response = await client.delete(`/guarantors/${id}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addGuarantorChattel = async (
  guarantorId,
  name,
  location,
  value,
  fileUrl,
  description,
  condition,
  images
) => {
  try {
    const response = await client.post(
      `/guarantors/${guarantorId}/upload-chattel`,
      {
        name,
        location,
        value,
        fileUrl,
        description,
        condition,
        images,
      }
    );
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanApplicationById = async (applicationId) => {
  try {
    const response = await client.get(`/loan-applications/${applicationId}`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getGuarantorChattels = async (guarantorId) => {
  try {
    const response = await client.get(`/guarantors/${guarantorId}/chattels`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateLoanApplication = async (loanApplicationId, status) => {
  try {
    const response = await client.patch(
      `/loan-applications/${loanApplicationId}`,
      { status: status }
    );
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const reassignALoanOfficer = async (
  loanApplicationId,
  loanOfficerId,
  reason,
  document
) => {
  try {
    const formData = new FormData();
    formData.append("newOfficerId", loanOfficerId);
    formData.append("reason", reason);

    if (document) {
      formData.append("document", document);
    }

    const response = await client.patch(
      `/loan-applications/${loanApplicationId}/reassign-officer`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanApplicationStatistics = async (fromDate, toDate) => {
  try {
    const params = new URLSearchParams();
    if (fromDate) params.append("from", fromDate);
    if (toDate) params.append("to", toDate);
    const response = await client.get(
      `/applications/status-counts/all?${params.toString()}`
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const updateApplicationStage = async (applicationId, stage) => {
  try {
    const response = await client.patch(`/loan-applications/${applicationId}`, {
      application_stage: stage,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanApplicationApprovals = async (loanApplicationId) => {
  try {
    const response = await client.get(
      `/loan-applications/${loanApplicationId}/approvals`
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getLoanApplicationDocuments = async (loanApplicationId) => {
  try {
    const response = await client.get(`/loans/${loanApplicationId}/documents`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addLoanApplicationDocument = async (loanId, documents) => {
  try {
    const response = await client.post(
      `/loan-applications/upload-document-urls`,
      {
        loanId,
        documents,
      }
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteLoanApplicationDocument = async (loanId, documentId) => {
  try {
    const response = await client.delete(`/${loanId}/documents/${documentId}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const deleteGuarantorChattelImage = async (
  guarantorId,
  chattelId,
  imageId
) => {
  try {
    const response = await client.delete(
      `guarantors/${guarantorId}/chattels/${chattelId}/images/${imageId}`
    );
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const addLoanGuarantorDocument = async (loanId, documents) => {
  try {
    const response = await client.post(`/guarantors/documents/urls`, {
      guarantorRequestId: loanId,
      documents,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getGuarantorDocuments = async (guarantorId) => {
  try {
    const response = await client.get(`/guarantors/${guarantorId}/documents`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
